import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { useCompanyUsers } from './useCompanyUsers'

/**
 * Hook to fetch company users for the current context company
 * Uses the company from Redux context
 */
export const useCtxCompanyUsers = () => {
  const companyId = useSelector(contextCompanyIdSelector)

  return useCompanyUsers(companyId || '')
}
